import { useBookingV2 } from "context/BookingV2Context"
import { useMemo } from "react"
import SelectSeat from "./SelectSeat"
import SelectSeatV2 from "./SelectSeatV2"

const SelectSeatWrapper = () => {
    const { event } = useBookingV2()

    // Check if current event is one of the EID party events
    const isEidPartyEvent = useMemo(() => {
        return [
            process.env.NEXT_PUBLIC_EID_PARTY_1,
            process.env.NEXT_PUBLIC_EID_PARTY_2,
            process.env.NEXT_PUBLIC_EID_PARTY_3,
        ].includes(event?._id)
    }, [event?._id])

    // Render SelectSeatV2 for Eid events, otherwise render SelectSeat
    return isEidPartyEvent ? <SelectSeatV2 /> : <SelectSeat />
}

export default SelectSeatWrapper
